<template>
  <div class="page">
    <div class="header">
      <!-- PC端显示的菜单 -->
      <div class="wp" v-if="!isMobile">
        <a-row :gutter="20">
          <a-col :span="4">

          </a-col>
          <a-col :span="20">
            <HeaderWebComponents
                :menu-list="menuList"
            ></HeaderWebComponents>
          </a-col>
        </a-row>

      </div>
      <!-- 移动端显示的菜单 -->
      <div v-else>
        <a-flex justify="space-between" align="center" horizontal>
          <div class="logo">
            <img class="image" src="@/assets/logo.png" alt="">
          </div>
          <HeaderMobileComponents
              :menu-list="menuList"
          ></HeaderMobileComponents>
        </a-flex>

      </div>

    </div>
  </div>

</template>

<script setup>
import {ref, computed, onMounted, onUnmounted, reactive} from 'vue';
import {useRouter} from 'vue-router';
import {getListItem} from "@/api/nav";
import HeaderWebComponents from "@/pages/components/HeaderWebComponents.vue";
import HeaderMobileComponents from "@/pages/components/HeaderMobileComponents.vue";

const router = useRouter();
const isMobile = ref(false);
const menuList = reactive([]);

// 检测设备类型
const checkDeviceType = () => {
  isMobile.value = window.innerWidth <= 768;
};


const getListFunc = async () => {
  let params = {
  }
  const {data} = await getListItem(params)
// 处理原始数据转换为菜单格式
  const dataList = data.map(item => {
    const menuItem = {
      key: item.name.toLowerCase().replace(/\s+/g, '_'), // 将名称转换为小写并用下划线替换空格
      label: item.name,
      path: item.url
    };

    // 如果有子菜单，递归处理
    if (item.children && item.children.length > 0) {
      menuItem.children = item.children.map(child => ({
        key: child.name.toLowerCase().replace(/\s+/g, '_'),
        label: child.name,
        path: child.url
      }));
    }

    return menuItem;
  });

  Object.assign(menuList,dataList)
}
getListFunc()
// 监听窗口大小变化
onMounted(() => {
  checkDeviceType();
  window.addEventListener('resize', checkDeviceType);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkDeviceType);
});
</script>

<style scoped>
.header {
  border-bottom: 1px solid rgba(5, 5, 5, 0.06);
  height: 66px;
  line-height: 66px;
  padding: 0 10px;
  background: #fff;
}
.image{
  width: 40px;
  height: 40px;
}
</style>